<template>
    <div class="search-range">
        <b-form-checkbox
            class="search-range__checkbox"
            :checked="isChecked"
            @change="handleCheckChanged"
        >
            {{ label }}
        </b-form-checkbox>

        <div class="search-range__slider px-2 pt-1" v-show="isChecked">
            <div class="dual-range-input">
                <input type="range" :min="min" :max="max" step="1" :value="transformedValue[0]" id="min" ref="min"
                    @input="handleChanged([Number($event.target.value), transformedValue[1]])" />
                <input type="range" :min="min" :max="max" step="1" :value="transformedValue[1]" id="max" ref="max"
                    @input="handleChanged([transformedValue[0], Number($event.target.value)])" />
            </div>
            <div class="d-flex" style="gap: .5rem;font-size: .875rem">
                <div class="text-right" style="flex:1; min-width: 0">
                    {{ tooltipFormatter(transformedValue[0]) }}
                </div>
                -
                <div class="text-left" style="flex:1; min-width: 0">
                    {{ tooltipFormatter(transformedValue[1]) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DualRangeInput from '@stanko/dual-range-input';
    import '@stanko/dual-range-input/dist/index.css';
    import { BFormCheckbox } from 'bootstrap-vue';

    export default {
        components: {
            BFormCheckbox,
            // VueSlider,
        },
        props: {
            value: Object,
            label: String,
            min: Number,
            max: Number,
            name: String,
            unit: String,
        },
        computed: {
            isChecked() {
                return !!this.value;
            },
            transformedValue() {
                return this.value
                    ? [this.value.min, this.value.max]
                    : [this.min, this.max];
            },
            collapseId() {
                return `range-${this.name}`;
            },
        },
        methods: {
            tooltipFormatter(value) {
                return this.unit ? `${value} ${this.unit}` : value;
            },
            handleCheckChanged(active) {
                this.$emit('input', active ? {
                    min: this.min,
                    max: this.max,
                } : null);
            },
            handleChanged(value) {
                console.log(value);
                const [min, max] = value;
                if(this.value && this.value.min === min && this.value.max === max) {
                    return;
                }
                this.$emit('input', { min, max });
            },
        },
        mounted() {
            new DualRangeInput(this.$refs.min, this.$refs.max);
        }
    }
</script>

<style>
    .dual-range-input {
        --dri-thumb-border-width: 0;
        --dri-thumb-color: var(--primary);
        --dri-thumb-hover-color: var(--primary);
        --dri-thumb-width: .875rem;
        --dri-thumb-height: .875rem;
        --dri-track-color: #ccc;
        --dri-track-filled-color: var(--primary);
        --dri-track-height: .25rem;
    }
</style>
